import axios from "axios";

// CORREÇÃO: Mude 'backend' para 'localhost'
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const apiClient = axios.create({
  baseURL: "/",
});

// O resto do arquivo permanece igual...
export const loginUser = (username, password) => {
  return apiClient.post("/api/login", { username, password });
};

// ...
export const getCollections = () => {
  return apiClient.get("/api/collections");
};

export const createCollection = (formData) => {
  return apiClient.post("/api/collections", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateCollectionName = (collectionId, newName) => {
  return apiClient.put(`/api/collections/${collectionId}`, {
    new_name: newName,
  });
};

export const updateCollection = (collectionId, { newName, newPageTitle }) => {
  const payload = {};
  if (newName !== undefined) payload.new_name = newName;
  if (newPageTitle !== undefined) payload.new_page_title = newPageTitle;
  return apiClient.put(`/api/collections/${collectionId}`, payload);
};

export const deleteCollection = (collectionId) => {
  return apiClient.delete(`/api/collections/${collectionId}`);
};

export const getCollectionPdfs = (collectionId) => {
  return apiClient.get(`/api/collections/${collectionId}/pdfs`);
};


export const reorderPdfs = (collectionId, ordered_filenames) => {
  return apiClient.post(`/api/collections/${collectionId}/reorder`, {
    ordered_filenames,
  });
};


export const addPdfs = (collectionId, formData) => {
  return apiClient.post(`/api/collections/${collectionId}/pdfs`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deletePdf = (collectionId, filename) => {
  return apiClient.delete(`/api/collections/${collectionId}/pdfs/${filename}`);
};